var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAssetVideoCam(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    width: 40,
    height: 40,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M199.8,157.6c0-38.8,31.5-70.3,70.3-70.3s70.3,31.5,70.3,70.3s-31.5,70.3-70.3,70.3S199.8,196.4,199.8,157.6z M31,157.6   c0-38.8,31.5-70.3,70.3-70.3s70.3,31.5,70.3,70.3s-31.5,70.3-70.3,70.3S31,196.4,31,157.6z M368.5,298.2V256   c0-15.5-12.7-28.1-28.1-28.1H59.1C43.7,227.9,31,240.5,31,256v140.6c0,15.5,12.7,28.1,28.1,28.1h281.2c15.5,0,28.1-12.7,28.1-28.1   v-42.2L481,424.8V227.9L368.5,298.2z M312.2,368.5h-225v-84.4h225V368.5z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssetVideoCam);
export default __webpack_public_path__ + "static/media/asset-video-cam.902b2041eded5d38502d2f5bffb88e50.svg";
export { ForwardRef as ReactComponent };